import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import RefreshableTimeago from "@Shared/components/general/refreshable-timeago.vue";
import { CAMPAIGNS_STATUS } from "@Shared/@Utils/constants";
import { GET_CLIENT_PROFILE_CAMPAIGNS } from "../../store/board-getters";
import { LOAD_CLIENT_PROFILE_CAMPAIGNS } from "@Broker/@Modules/clients/board/store/board-actions";
import CoApplicantsInfoLoader from "./co-applicants-info-loader.vue";
import CollapsibleCard from "@Broker/@Modules/clients/board/client-profile/components/shared/collapsible-card.vue";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { CURRENT_USER_USERNAME } from "@Broker/@Modules/main/store/account/account-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientProfileCampaigns",
  components: {
    RefreshableTimeago,
    CoApplicantsInfoLoader,
    CollapsibleCard,
    ProfileAvatar
  },
  props: {
    clientProfileId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      searchText: "",
      loading: true
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("BoardStore", [GET_CLIENT_PROFILE_CAMPAIGNS])), mapGetters("AccountStore", [CURRENT_USER_USERNAME])), {}, {
    filteredCampaigns() {
      var _context;
      return _filterInstanceProperty(_context = this.GET_CLIENT_PROFILE_CAMPAIGNS(this.clientProfileId)).call(_context, ({
        name,
        givenName,
        familyName
      }) => {
        var _context2;
        const stringToEvaluate = `${name} ${givenName} ${familyName}`;
        return _includesInstanceProperty(_context2 = stringToEvaluate.toLowerCase()).call(_context2, this.searchText.toLowerCase());
      });
    },
    campaignsStatus() {
      return CAMPAIGNS_STATUS();
    }
  }),
  async activated() {
    this.loading = true;
    await this.LOAD_CLIENT_PROFILE_CAMPAIGNS(this.clientProfileId);
    this.loading = false;
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [LOAD_CLIENT_PROFILE_CAMPAIGNS])), {}, {
    campaignDetailsLink(campaignId) {
      return {
        name: "marketing-campaign-details",
        params: {
          campaignId
        }
      };
    },
    isOwner(username) {
      return this.CURRENT_USER_USERNAME === username;
    }
  })
});